import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';
import { PrimaryButton, NegativeButton, FlatButton } from '../../../components';
export const ConfirmDialog = (props) => {
    const { t } = useTranslation();
    const { children, isOpen, title, positiveLabel = t('はい'), negativeLabel = t('いいえ'), isCancel = false, isNegative = false, onClose, onClickPositive, onClickNegative, loading, disabled = false, } = props;
    return (React.createElement(Dialog, { open: isOpen, fullWidth: true, onClose: onClose },
        title !== '' && React.createElement(DialogTitle, null, title),
        React.createElement(DialogContent, null, children),
        React.createElement(DialogActions, null,
            isCancel ? (React.createElement(FlatButton, { loading: loading, onClick: onClickNegative }, negativeLabel)) : (React.createElement(NegativeButton, { loading: loading, disabled: disabled, onClick: onClickNegative }, negativeLabel)),
            isNegative ? (React.createElement(NegativeButton, { loading: loading, disabled: disabled, onClick: onClickPositive }, positiveLabel)) : (React.createElement(PrimaryButton, { loading: loading, disabled: disabled, onClick: onClickPositive }, positiveLabel)))));
};
